import { normalizeList } from '../../../lib/admin-api/index.js';

function normalizeUsers(payload) {
  if (!payload || typeof payload !== 'object') {
    return [];
  }

  if (Array.isArray(payload.users)) {
    return payload.users;
  }

  if (payload.users && typeof payload.users === 'object') {
    return Object.values(payload.users);
  }

  return normalizeList(payload);
}

export function mapSystemUsersResponseToDto(payload) {
  return normalizeUsers(payload).map((item, index) => ({
    id: String(item?.id || item?.uid || `system-user-${index}`),
    firstName: String(item?.firstName || item?.first_name || '').trim(),
    lastName: String(item?.lastName || item?.last_name || '').trim(),
    email: String(item?.email || '').trim(),
    disabled: Boolean(item?.disabled),
  }));
}

export function mapSystemUserPayloadFromForm(form, { includePassword = true } = {}) {
  const payload = {
    firstName: String(form.firstName || '').trim(),
    lastName: String(form.lastName || '').trim(),
    email: String(form.email || '').trim(),
    disabled: Boolean(form.disabled),
  };

  const password = String(form.password || '').trim();
  if (includePassword && password) {
    payload.password = password;
  }

  return payload;
}
